/**
 * Browse a photo gallery
 */
goog.module('yext.location.gallery.browse');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');
const ui = goog.require('yext.location.gallery.photo.ui');
const textfield = goog.require('yext.textfield');
const embed = goog.require('yext.textfield.embed');


var $galleryBrowse;
var $photoPrevious;
var $photoNext;
var $photoContainer;
var $captionContainer;

var photos = [];
var currentPhotoIndex = 0;
var maxWidth = 700;
var maxHeight = 450;

/**
 * Initialize browse module
 */
function init() {
  $galleryBrowse = $('.js-gallery-browse');
  $photoPrevious = $galleryBrowse.find('.gallery-prev');
  $photoNext = $galleryBrowse.find('.gallery-next');
  $photoContainer = $galleryBrowse.find('.photo');
  $captionContainer = $galleryBrowse.find('.caption');

  bindEvents();
}

/**
 * Bind navigation events
 */
function bindEvents() {
  $photoPrevious.click(function() {
    showPhoto(--currentPhotoIndex);
  });

  $photoNext.click(function() {
    showPhoto(++currentPhotoIndex);
  });
}

/**
 * Show photo at a particular index
 *
 * @param {number} index Index of photo to show
 * @suppress {deprecated}
 */
function showPhoto(index) {
  // Cycle if index is out of bounds
  index = parseInt(index >= photos.length?0:(index < 0?photos.length - 1:index));

  // In case of over/underflow
  if (!photos[index]) {
    return;
  }

  var photo = photos[index];
  var description = photo.description;
  var img = new Image();

  img.onerror = function() {
    helpers.fallbackImage(function(img) {
      $photoContainer.html(img);
    });
  };

  var photoUrl = photo.url;

  if (photo.croppedImage) {
    photoUrl = photo.croppedImage;
  }

  img.src = yext.getDynamicThumbnailUrl(photoUrl, maxWidth, maxHeight);
  $photoContainer.empty().append(img);
  $captionContainer.html(yext.storm.location.util.generateEmbeddedFieldBadges(description));

  currentPhotoIndex = index;

  $galleryBrowse.dialog('option', 'title', getCurrentTitle());
}

/**
 * Build title string.
 * TODO(mattjs) Remove inline markup when adding new browse
 *
 * @return {string} Title for browse
 */
var getCurrentTitle = function() {
  // EXAMPLE: Photo 2 of 7
  return '<div style="text-align:center">' + yext.msg('Photo {0} of {1}', 1+currentPhotoIndex, photos.length) + '</div>';
};

/**
 * Show the gallery with a set of photos
 *
 * @param {array} _photos Array of Photo objects
 * @suppress {deprecated}
 */
function showGallery(_photos, startingPhotoUrl) {
  photos = _photos;

  if (startingPhotoUrl) {
    for (var i in photos) {
      if (areEquivalentUrls(startingPhotoUrl, photos[i].url)) {
        currentPhotoIndex = i;
        break;
      }
    }
  }

  // TODO(mattjs) Remove this when gallery is extracted from LocationEdit
  $photoPrevious.removeClass('disabled');
  $photoNext.removeClass('disabled');

  showPhoto(currentPhotoIndex);

  $galleryBrowse.dialog({
    draggable: false,
    modal: true,
    resizable: false,
    minWidth: 450,
    width: 'auto',
    title: getCurrentTitle(),
  });
}

/**
 * Checks if two urls point to the same image.
 *
 * @param {string} a The first url
 * @param {string} b The second url
 * @return True if both urls are exactly equal or if theyr unique identifier is the same when they are both mktgcdn urls.
 */
var areEquivalentUrls = function(a, b) {
  if (a == b) {
    return true;
  }
  if (a.indexOf('mktgcdn') > 0 && b.indexOf('mktgcdn') > 0) {
    var lastSlash = a.lastIndexOf('/');
    var secondToLastSlash = a.lastIndexOf('/', lastSlash-1);
    var uniqueId = a.substring(secondToLastSlash + 1, lastSlash);
    if (b.indexOf(uniqueId) > 0) {
      return true;
    }
  }
  return false;
};

exports = {
  init,
  bindEvents,
  showPhoto,
  showGallery,
};
